
import Vue from 'vue'

export default Vue.extend({
    name: 'TrustedBy',
    components: {
    },
    computed: {
        namecardWorkspaceUrl() {
            return process.env.VUE_APP_NAMECARD_WORKSPACE_URL;
        }
    },
    data(){
        return{
        }
    },
    methods: {
    },
    mounted() {
    }
})
